const CryptoJS = require('crypto-js'); //引用AES源码js    js加密
/*-----------------------------------------------------对称加密 start---------------------------------------------*/

const aeskey = CryptoJS.enc.Utf8.parse('1234567816253425');

export const encryptAES = (str, key) => {

  const keys = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Utf8.parse(key);
  const srcs = CryptoJS.enc.Utf8.parse(str);
  const encrypted = CryptoJS.AES.encrypt(srcs, keys, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
};


//不带偏移量的加密
export const aesEncrypt = (data) => {

  const cipher = CryptoJS.AES.encrypt(data, aeskey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
    iv: '',
  });
  // 将加密后的数据转换成 Base64
  const base64Cipher = cipher.ciphertext.toString(CryptoJS.enc.Base64);
  // 处理 Android 某些低版的BUG
  const resultCipher = base64Cipher.replace(/\+/g, '-').replace(/\//g, '_');
  // 返回加密后的经过处理的 Base64
  return resultCipher;
}

/**
 * 定义解密函数
 */
export const aesDecrypt = (encrypted) => {
  // 先将 Base64 还原一下, 因为加密的时候做了一些字符的替换
  const restoreBase64 = encrypted.replace(/\-/g, '+').replace(/_/g, '/');
  // 这里 mode, padding, iv 一定要跟加密的时候完全一样
  // 返回的是一个解密后的对象
  const decipher = CryptoJS.AES.decrypt(restoreBase64, aeskey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
    iv: '',
  });
  // 将解密对象转换成 UTF8 的字符串
  const resultDecipher = CryptoJS.enc.Utf8.stringify(decipher);
  // 返回解密结果
  return resultDecipher;
}


//带偏移量的加密

//加密方法 AES
export function Encrypt(word, keys, ivs) {
  const key = CryptoJS.enc.Utf8.parse(keys); //十六位十六进制数作为密钥
  const iv = CryptoJS.enc.Utf8.parse(ivs); //十六位十六进制数作为密钥偏移量
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString().toUpperCase();
}

//解密方法 AES 
export function Decrypt(word, keys, ivs) {
  const key = CryptoJS.enc.Utf8.parse(keys); //十六位十六进制数作为密钥
  const iv = CryptoJS.enc.Utf8.parse(ivs); //十六位十六进制数作为密钥偏移量
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

/*-----------------------------------------------------对称加密 end---------------------------------------------*/







/*-----------------------------------------------------非对称加密 start---------------------------------------------*/
//加密方法 RSA
export function EncryptRSA(word) {
  //公钥
  const PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwTAm1NoyG4c1tAJykM0NuafZ+eb+4Gw9FZhpNEP5BXwHoGZI8fz7O91RUBPpBCQWY0eq0DCtE+StznaKuuIobZ74iZhapZNUhuKwhg/b/p0jgTKVMYvJNJmdCTAvnYDR7POuTDZ9Fw9kzohnCZsVl3Qh4MLqTJttv7Ui5l/oG+MZn2FJ4b6Q10tt/clvIZqz0zQka/qYqS5M3xoVNFvfJbEruUVajKyfkfGlFuWA+stt9z1INeBzM66OY2f1gGkIgCfSeTRM82a6vcww+Yys4cUF+O/eO5hBLEkQNEQT0wu+5e7ryFkJM/xtqKcWmBK7nV45i3sa4t3i4Nm0e7KJeQIDAQAB';
  //使用公钥加密
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(PUBLIC_KEY);
  const encrypted = encrypt.encrypt(word);
  return encrypted;
}

//解密方法 RSA 
export function DecryptRSA(word) {
  //私钥
  const PRIVATE_KEY = 'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDBMCbU2jIbhzW0AnKQzQ25p9n55v7gbD0VmGk0Q/kFfAegZkjx/Ps73VFQE+kEJBZjR6rQMK0T5K3Odoq64ihtnviJmFqlk1SG4rCGD9v+nSOBMpUxi8k0mZ0JMC+dgNHs865MNn0XD2TOiGcJmxWXdCHgwupMm22/tSLmX+gb4xmfYUnhvpDXS239yW8hmrPTNCRr+pipLkzfGhU0W98lsSu5RVqMrJ+R8aUW5YD6y233PUg14HMzro5jZ/WAaQiAJ9J5NEzzZrq9zDD5jKzhxQX47947mEEsSRA0RBPTC77l7uvIWQkz/G2opxaYErudXjmLexri3eLg2bR7sol5AgMBAAECggEAXnnf46Q5cQD0oG25/VpqZerSTMZMyw/j55W7jVXYiHgZerXK4pzneGVJiLHT+LR1RmQcAuhrHBlvblLGkZJcVw+xWAjr+6FLaxOdZFKJMcFDRcGo+Kv14AVnqMCp6IrBHvIkwRy8m/RpRh+q1CXFr2WZ08M+tewlBeXdhXBNoKTaixFX+gFtb5zEgVx1gt7v4XvDfqfWnjMi9NYGO8uCckAGtnGiDvmPKwwyy0d4MUj1fY8mn7KW0SBYxeGWorDD7bO/KsLgdtFxeSrcajTkMBgoKUKymy0WnpbYqMscDgzsisbVG9h2bt5QfIrx2mAhku+EflUbaZojYt0Lf07xoQKBgQD2n7DIgxMe7MopDB3CjvxeRIWiYM58SKBD4bSNMuTrig7Fa0P9iIZ4jv1nfWKHyItHVJCN/ZyD8x82ZBDvnqeXh7hVG2ii+bUpkisApATj+cjARc6JNXwqh4+u7NyUmap/OSJYuHZdqmNgNShTfwlKEDi9M/kR8Uzo5NXRa2hLDQKBgQDIiGOHflIuUT0ihEw7dXXhIL6KAwfF//SqXrFXG4m4aAf+QWoLNANn0ULCWz0igHBv8NXgrk+sED370dL8MuG0t4P6jwfAlR2SbXXJt8hOCMeJX+jMKq3UksGpO76N3S4bnylTkmOSB9vNKSbhWA78v9OWFC0lRxWT0Ok820PtHQKBgQDRDYJsJXeS0kN3Ufb0EgJo4gqpHwhJH8MCZ5OF0SttYYSt4gQrKIxcK1EwZX+c++jcGRnD0sPWscK2d1JH3CPR9dDSC77Bz4u6ZlWfYGlo2jZKjaHKexT6dBjevZcpO6zj1QmBTTPAqAs+5TB+voOgTWnbL/AkPnfkPv3kW/h3DQKBgQDHic9ft3aW2Ad5HSOt1odhaG+wbKuDfdk63dag0qoLcJjjiru2Qh9RYoyHULpYZm17Na3cUBa/I7pJpNPIV+j3JdSRsVkJbFdsqLaX7ePGoj3KmEDRR3aJGy7Q8r3986Q5n/pDSlsBqAgy8Uva1wCyxz4HDDSP71etKiergpLokQKBgAFgzVfkkwBh0FYGgUgbRJK8loMCbzNsHWYoR3nBSuV1C4A2ZKv3HN8Vq6rMNh8qRd05tRbVbvlRHVWnvn8EX6LC89gV1M3igSbwPRk6OLLKgaT1vVuW7+oF0Y8bigXVfxaX8Oz1+ybAdMrK+UzSRLZHC1EW9r98srlOEQ3aymyg';
  //使用私钥解密
  const decrypt = new JSEncrypt();
  decrypt.setPrivateKey(PRIVATE_KEY);
  const uncrypted = decrypt.decrypt(word);
  return uncrypted;
}
/*-----------------------------------------------------非对称加密 end---------------------------------------------*/



// WEBPACK FOOTER //
// ./src/utils/encrypt.js